import styled from '@emotion/styled'

export const DetailsSectionWrapper = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing(3)};

  &:last-of-type {
    margin-bottom: 0;
  }
`
